import React from 'react';

const FiltersInputs: React.FC<React.PropsWithChildren<{}>> = (props) => (
  <div className="content-inputs">{props.children}</div>
);

export default FiltersInputs;